import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyB11w24K7hnSohZUUX9B080gLeGtZeEzSo",
  authDomain: "resume-builder-9e399.firebaseapp.com",
  projectId: "resume-builder-9e399",
  storageBucket: "resume-builder-9e399.firebasestorage.app",
  messagingSenderId: "14623796512",
  appId: "1:14623796512:web:a53f52330cf9764d45bb45"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();